import React, { useEffect, useState, useRef } from "react";
import { useFormik, FormikProvider, FieldArray, isNaN } from "formik";
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useNavigate, useLocation } from "react-router-dom";
import Spinner from "../../components/Spinner/spinner";
import { useParams } from "react-router-dom";
import {
  getUserProjects,
  addNewTimeSheet,
  updateTimesheet,
  getConstantProjects,
} from "../../services/addTimeSheet";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "./addTimeSheet.css";
import "../../global.css";
import {
  addDays,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  format,
  addWeeks,
  eachWeekOfInterval,
  parse,
  isSameMonth,
  parseISO,
} from "date-fns";
import { getTimesheetById } from "../../services/viewTimeSheet";
import { appInsights } from "../../AppInsights";
import { Tooltip } from "primereact/tooltip";

const AddNewTimeSheet = () => {
  const navigate = useNavigate();
  const currentUserTypeId = localStorage.getItem("userTypeId");
  const { id } = useParams();
  const location = useLocation();
  const fileInputRef = useRef(null);
  const toast = useRef(null);
  const [viewType, setViewType] = useState("monthly");
  const [monthList, setMonthList] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [weekList, setWeekList] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);
  const [biWeeklyPeriods, setBiWeeklyPeriods] = useState([]);
  const [initialEntries, setInitialEntries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [selectedFile, setSelectedFile] = useState([]);
  const [projects, setProjects] = useState([]);
  const [projects1, setProjects1] = useState([]);
  const [loadingProjects, setLoadingProjects] = useState(false);
  const [isExternalUser, setIsExternalUser] = useState(false);
  const [defaultProject, setDefaultProject] = useState({
    label: "Select a Project",
    value: null,
  });
  const [timesheetDataOnEdit, setTimesheetDataOnEdit] = useState(null);
  const [constantProjects, setConstantProjects] = useState([]);
  const hasInitialized = useRef(false);

  const options = [
    { label: "Bi-Weekly", value: "biweekly" },
    { label: "Monthly", value: "monthly" },
    { label: "Weekly", value: "weekly" },
  ];
  const showToast = (severity, summary, detail) => {
    if (toast?.current) {
      toast?.current?.show({
        severity,
        summary,
        detail,
        life: 5000,
        closable: true,
      });
    }
  };
   useEffect(() => {
    const fetchProjects = async () => {
      setLoadingProjects(true);
      try {
        const data = await getUserProjects(currentUserTypeId);
        const allprojects = data?.map((project) => ({
          label: project?.name,
          value: parseInt(project?.projectId), // Ensure projectId is a number
          type: project?.projectType == "Default" ? 0 : 1,
        }));
        const formattedProjects = data
          ?.filter(
            (project) => project?.projectId !== 1 && project?.projectId !== 2
          )
          .map((project) => ({
            label: project?.name,
            value: parseInt(project?.projectId), // Ensure projectId is a number
            type: project?.projectType == "Default" ? 0 : 1,
          }));

        let defaultObj = { label: "Select a Project", value: null };
        let allProjects = [defaultObj, ...formattedProjects];
        let defaultProjectObj = [
          defaultObj,
          ...constantProjects,
          ...allprojects,
        ];
        setProjects1(defaultProjectObj);
        setProjects(allProjects);
      } catch (error) {
        console.error("Error fetching projects:", error);
        appInsights.trackException("Get addTimeSheet", { exception: error });
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: error?.message || "Something went wrong at Server Side",
          life: 3000,
        });
      } finally {
        setLoadingProjects(false);
      }
    };
    fetchProjects();
  }, [constantProjects]);

  useEffect(() => {
    const fetchConstantProjects = async () => {
      try {
        const data = await getConstantProjects();
        const allprojects = data?.map((project) => ({
          label: project?.name,
          value: `dp-${project?.id}`, // Ensure projectId is a number
          type: project?.projectType == "Default" ? 0 : 1,
        }));
        setConstantProjects(allprojects);
      } catch (error) {
        console.error("Error fetching projects:", error);
        appInsights.trackException("Get default project", { exception: error });
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: error?.message || "Something went wrong at Server Side",
          life: 3000,
        });
      } finally {
        setLoadingProjects(false);
      }
    };
    fetchConstantProjects();
  }, []);
  const getFileName = (url) => {
    return url?.split("/").pop();
  };

  useEffect(() => {
    if (id) {
      getTimesheetData(id);
    }
  }, [id]);

  useEffect(() => {
    const initializeData = async () => {
      const userType = localStorage.getItem("userType");
      if (!userType || !["internal", "external"].includes(userType)) {
        navigate("/select-user-type");
        return;
      }
      setIsExternalUser(userType === "external");

      const idToken = localStorage.getItem("idToken");
      if (!idToken) {
        window.location.href = "/";
        return;
      }
      if (id !== null && id !== undefined && timesheetDataOnEdit?.length > 0) {
        const periodType = timesheetDataOnEdit[0]?.periodType;
        if (periodType) {
          const normalizedType = periodType.toLowerCase();
          setViewType(
            normalizedType === "bi-weekly" ? "biweekly" : normalizedType
          );
        }
      }
      await getMonthList();
      setLoading(false);
    };
    initializeData();
  }, [navigate, timesheetDataOnEdit]);
  useEffect(() => {
    if (monthList?.length > 0) {
      setCurrentMonth();
    }
  }, [monthList]);

  const setCurrentMonth = () => {
    if (id !== null && id !== undefined && timesheetDataOnEdit?.length > 0) {
      setSelectedMonth(timesheetDataOnEdit[0]?.monthYear);
    } else {
      const today = new Date();
      const prevMonthDate = new Date(
        today.getFullYear(),
        today.getMonth() - 1,
        1
      );
      const currentMonth = format(prevMonthDate, "MMMM yyyy");
      const foundMonth = monthList.find((m) => m.value === currentMonth);
      setSelectedMonth(foundMonth ? foundMonth.value : monthList[0].value);
    }
  };

  useEffect(() => {
    if (selectedMonth) {
      if (viewType === "weekly") {
        getWeekList(selectedMonth);
      } else if (viewType === "biweekly") {
        getBiWeeklyPeriods(selectedMonth);
      } else if (viewType === "monthly") {
        handleSelectedDatesForMonth(selectedMonth);
      }
    }
  }, [selectedMonth, viewType]);

  useEffect(() => {
    if (
      id !== null &&
      id !== undefined &&
      weekList?.length > 0 &&
      timesheetDataOnEdit?.length > 0
    ) {
      const result = weekList.find(
        (week) =>
          week?.label?.trim()?.toLowerCase() ===
          timesheetDataOnEdit[0]?.weekRange.trim().toLowerCase()
      );
      setSelectedWeek(result?.value);
    } else {
      if (viewType === "weekly" && weekList.length > 0) {
        // Find the current week in the weekList
        const today = new Date();
        const currentWeek = weekList?.find((week) => {
          const weekStart = week?.value;
          const weekEnd = week?.endDate;
          return today >= weekStart && today <= weekEnd;
        });
        // Set current week if found, otherwise default to first week
        setSelectedWeek(currentWeek ? currentWeek.value : weekList[0]?.value);
      } else if (viewType === "biweekly" && biWeeklyPeriods?.length > 0) {
        setSelectedWeek(biWeeklyPeriods[0]?.value);
      }
    }
  }, [weekList, biWeeklyPeriods, viewType]);

  useEffect(() => {
    if (selectedWeek) {
      if (viewType === "weekly" || viewType === "biweekly") {
        const period =
          viewType === "weekly"
            ? weekList.find((w) => w?.value === selectedWeek)
            : biWeeklyPeriods.find((p) => p?.value === selectedWeek);
        if (period) {
          const startDate = selectedWeek;
          const endDate = period?.endDate;
          let dateList = [];
          let currentDate = startDate;
          while (currentDate <= endDate) {
            dateList.push(format(currentDate, "EEE, MMM dd"));
            currentDate = addDays(currentDate, 1);
          }
          setSelectedDates(dateList);
        }
      }
    }
  }, [selectedWeek, viewType]);

  const handleSelectedDatesForMonth = (selectedMonth) => {
    const parsedDate = parse(selectedMonth, "MMMM yyyy", new Date());
    const startDate = startOfMonth(parsedDate);
    const endDate = endOfMonth(parsedDate);
    let dateList = [];
    let currentDate = startDate;
    while (currentDate <= endDate) {
      dateList.push(format(currentDate, "EEE, MMM dd"));
      currentDate = addDays(currentDate, 1);
    }
    setSelectedDates(dateList);
  };

  const handleFileUpload = (event) => {
    const files = event.target.files;
    // You can convert to an array if needed
    if (files) {
      const filesArray = Array.from(files).map((file) => ({
        type: "uploaded",
        file,
      }));
      // const filesArray = Array.from(files);
      setSelectedFile((prev) => [...prev, ...filesArray]);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  useEffect(() => {
    if (
      id !== null &&
      id !== undefined &&
      timesheetDataOnEdit?.length > 0 &&
      timesheetDataOnEdit[0]?.blobPath
    ) {
      setSelectedFile(timesheetDataOnEdit[0]?.blobPath);
    }
  }, [id, timesheetDataOnEdit?.length]);

  const getWeekList = (monthYear) => {
    let [month, year] = monthYear?.split(" ");
    let monthIndex = new Date(`${month} 1, ${year}`).getMonth();
    let monthStart = startOfMonth(new Date(year, monthIndex, 1));
    let monthEnd = endOfMonth(monthStart);
    const data = eachWeekOfInterval(
      { start: monthStart, end: monthEnd },
      { weekStartsOn: 1 }
    );
    const weeks = data?.map((weekStart) => {
      const weekEnd = addDays(weekStart, 6);
      return {
        value: weekStart,
        label: `${format(weekStart, "MMM d")} - ${format(weekEnd, "MMM d")}`,
        endDate: weekEnd,
      };
    });
    setWeekList(weeks);
  };

const getBiWeeklyPeriods = (monthYear) => {
  let [month, year] = monthYear.split(" ");
  let monthIndex = new Date(`${month} 1, ${year}`).getMonth();
  let monthStart = startOfMonth(new Date(year, monthIndex, 1));
  let monthEnd = endOfMonth(monthStart);

  let periods = [];
  let currentStart = monthStart;

  while (currentStart <= monthEnd) {
    let periodEnd;

    if (currentStart.getDate() === 1) {
      // First period: 1st to 15th
      periodEnd = new Date(currentStart.getFullYear(), currentStart.getMonth(), 15);
    } else {
      // Second period: 16th to end of month (30 or 31)
      periodEnd = monthEnd;
    }

    periods.push({
      value: currentStart,
      label: `${format(currentStart, "MMM d")} - ${format(periodEnd, "MMM d")}`,
      endDate: periodEnd,
    });

    currentStart = addDays(periodEnd, 1);

    if (!isSameMonth(monthStart, currentStart)) break;
  }

  setBiWeeklyPeriods(periods);
};

  const [pendingHrs, setPendingHrs] = useState(null);
  let total = 0;

  const getMonthList = () => {
    return new Promise((resolve) => {
      setTimeout(() => {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        const currentYear = new Date().getFullYear();
        const currentMonthIndex = new Date().getMonth();
        const lastYear = currentYear - 1;
        const data = [
          ...months.map((month, index) => ({
            label: `${month} ${lastYear}`,
            value: `${month} ${lastYear}`,
            disabled: false,
          })),
          ...months.map((month, index) => ({
            label: `${month} ${currentYear}`,
            value: `${month} ${currentYear}`,
            disabled: index > currentMonthIndex, // disable months after current one
          })),
        ];

        setMonthList(data);
        resolve();
      }, 1000);
    });
  };

  const handleSubmit = async (values, isDraft = false) => {
    try {
      setSubmitting(true);

      // Check for any project with hours > 8
      const hasProjectExceeding8Hours = values?.entries.some((entry) =>
        entry?.projects.some((proj) => proj?.hours > 12)
      );

      if (hasProjectExceeding8Hours) {
        showToast("error", "Error", "Hours cannot exceed 12 for a project");
        setSubmitting(false);
        return;
      }

      // For draft, check if at least one project is selected
      if (isDraft) {
        const hasAnyProject = values?.entries.some((entry) =>
          entry?.projects.some((proj) => proj?.project)
        );
        if (!hasAnyProject) {
          showToast(
            "error",
            "Error",
            "Please select at least one project to save as draft"
          );
          setSubmitting(false);

          return;
        }

        const incompleteWeekdays = values?.entries?.filter((entry) => {
          const dayName = entry?.date?.split(",")[0];
          const isWeekend = dayName === "Sat" || dayName === "Sun";

          // Skip validation for weekends
          if (isWeekend) return false;

          // For weekdays, check if any project row is empty
          const hasEmptyProject = entry?.projects.some(
            (proj) =>
              (!proj?.project || proj?.project?.label) && proj?.hours > 0
          );

          return hasEmptyProject;
        });

        if (incompleteWeekdays.length > 0) {
          const missingDays = incompleteWeekdays
            ?.map((entry) => entry?.date)
            ?.join(", ");

          showToast(
            "error",
            "Error",
            "Please select a project when hours are entered"
          );
          // `Please fill in all project rows for weekdays before submitting. Incomplete days: ${missingDays}`
          setSubmitting(false);
          return;
        }
      }

      // Check if all weekdays have projects filled
      if (!isDraft) {
        const incompleteWeekdays = values?.entries?.filter((entry) => {
          const dayName = entry?.date?.split(",")[0];
          const isWeekend = dayName === "Sat" || dayName === "Sun";

          // Skip validation for weekends
          if (isWeekend) return false;

          // For weekdays, check if any project row is empty
          const hasEmptyProject = entry?.projects.some(
            (proj) => !proj?.project || proj?.project?.label
          );

          return hasEmptyProject;
        });

        if (incompleteWeekdays.length > 0) {
          const missingDays = incompleteWeekdays
            ?.map((entry) => entry?.date)
            ?.join(", ");

          showToast(
            "error",
            "Error",
            `${"Please select a project before submitting your timesheet"}`
            // `Please fill in all project rows for weekdays before submitting. Incomplete days: ${missingDays}`
          );
          setSubmitting(false);
          return;
        }
      }

      // Validate file upload for external users
      if (isExternalUser && !selectedFile && !isDraft) {
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Please upload a document before submitting",
          life: 3000,
        });
        setSubmitting(false);
        return;
      }

      // Validate hours without project selection
      const hasHoursWithoutProject = values?.entries.some((entry) =>
        entry?.projects.some(
          (proj) => !proj?.project && proj?.hours && proj?.hours > 0
        )
      );

      if (hasHoursWithoutProject) {
        showToast(
          "error",
          "Error",
          "Please select a project when hours are entered"
        );
        setSubmitting(false);
        return;
      }

      // Validate that no project has 0 hours (except for project IDs 1 and 2)
      const hasInvalidZeroHours = values?.entries?.some((entry) =>
        entry?.projects?.some((proj) => {
          if (!proj?.project) return false;
          const projectId = proj?.project;
          // if (isNaN(projectId)) return false; // skip if not a valid number
          return (
            (!proj?.hours || proj?.hours === 0) &&
            !["dp-1", "dp-2", "dp-3"].includes(projectId)
          );
        })
      );

      if (hasInvalidZeroHours) {
        showToast(
          "error",
          "Error",
          "Hours cannot be 0 when a project is selected"
        );
        setSubmitting(false);
        return;
      }
      const hasInvalidHoursForRestrictedProjects = values?.entries?.some(
        (entry) =>
          entry?.projects?.some((proj) => {
            if (!proj?.project) return false;
            const projectId = proj?.project;
            return ["dp-2", "dp-3"].includes(projectId) && proj?.hours > 0;
          })
      );

      if (hasInvalidHoursForRestrictedProjects) {
        showToast(
          "error",
          "Error",
          "Holidays cannot be taken for longer than 0 hours."
        );
        setSubmitting(false);
        return;
      }
      // Validate total hours per day
      const hoursValidation = values?.entries?.every((entry) => {
        const totalHours = entry?.projects?.reduce(
          (sum, proj) => sum + (proj?.hours || 0),
          0
        );
        if (totalHours > 12) {
          showToast(
            "error",
            "Error",
            `Total hours for ${entry?.date} cannot exceed 12 hours (current: ${totalHours})`
          );
          return false;
        }
        return true;
      });

      if (!hoursValidation) {
        setSubmitting(false);
        return;
      }

      const formData = new FormData();

      // Add basic timesheet info
      formData.append(
        "TimesheetTypeId",
        viewType === "weekly" ? 1 : viewType === "biweekly" ? 2 : 3
      );
      if (id !== null && id !== undefined) {
        formData.append("Id", id);
      }

      // Get userTypeId based on user type
      const userType = localStorage.getItem("userType");
      const userTypeId = userType === "internal" ? 1 : 2;

      // Format dates to UTC
      const year = parse(selectedMonth, "MMMM yyyy", new Date()).getFullYear();
      const startDate = parse(
        `${values?.entries[0]?.date} ${year}`,
        "EEE, MMM dd yyyy",
        new Date()
      );
      const endDate = parse(
        `${values?.entries[values?.entries.length - 1]?.date} ${year}`,
        "EEE, MMM dd yyyy",
        new Date()
      );
      if (startDate.getMonth() === 11 && endDate.getMonth() === 0) {
        endDate.setFullYear(endDate.getFullYear() + 1);
      }
      const utcStartDate = new Date(
        Date.UTC(
          startDate.getFullYear(),
          startDate.getMonth(),
          startDate.getDate()
        )
      );
      const utcEndDate = new Date(
        Date.UTC(endDate.getFullYear(), endDate.getMonth(), endDate.getDate())
      );

      formData.append("StartDate", utcStartDate.toISOString());
      formData.append("EndDate", utcEndDate.toISOString());
      formData.append("StatusId", isDraft ? 4 : 1); // 4 for draft, 1 for submit

      // Format projects and hours
      const projectsAndHours = JSON.stringify(
        values?.entries
          ?.filter((entry) =>
            entry?.projects?.some(
              (p) =>
                p?.project &&
                (p?.hours > 0 || ["dp-1", "dp-2", "dp-3"].includes(p?.project))
            )
          )
          ?.map((entry) => {
            const entryDate = parse(
              `${entry?.date} ${year}`,
              "EEE, MMM dd yyyy",
              new Date()
            );
            if (startDate.getMonth() === 11 && entryDate.getMonth() === 0) {
              entryDate.setFullYear(entryDate.getFullYear() + 1);
            }
            const utcDate = new Date(
              Date.UTC(
                entryDate.getFullYear(),
                entryDate.getMonth(),
                entryDate.getDate()
              )
            );

            return {
              entryDate: utcDate.toISOString(),
              projects: entry?.projects
                ?.filter(
                  (p) =>
                    p?.project &&
                    (p?.hours > 0 ||
                      ["dp-1", "dp-2", "dp-3"].includes(p?.project))
                )
                ?.map((project) => ({
                  ...(Number.isNaN(Number(project?.project))
                    ? {
                        projectId: null,
                        defaultProjectId: Number(project?.project.slice(3)),
                      }
                    : {
                        projectId: project?.project,
                        defaultProjectId: null,
                      }),
                  hours: parseFloat(project?.hours) || 0,
                  comments: project?.comments || "",
                })),
            };
          })
      );

      if (JSON.parse(projectsAndHours)?.length === 0 && !isDraft) {
        toast?.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Please add at least one project entry",
          life: 3000,
        });
        setSubmitting(false);
        return;
      }

      formData.append("ProjectsAndHours", projectsAndHours);

      if (selectedFile && selectedFile.length > 0) {
        for (const fileItem of selectedFile) {
          if (fileItem instanceof File) {
            // Direct File object
            formData.append("Files", fileItem);
          } else if (typeof fileItem === "string") {
            // Blob URL as string
            const blobFile = await fetch(fileItem).then((res) => res.blob());
            const fileName = getFileName(fileItem);
            const decodedFileName = decodeURIComponent(fileName);
            const file = new File([blobFile], decodedFileName, {
              type: blobFile.type,
            });
            formData.append("Files", file);
          } else if (
            fileItem.type === "uploaded" &&
            fileItem.file instanceof File
          ) {
            // File wrapped in custom structure
            formData.append("Files", fileItem.file);
          } else if (fileItem.blobPath && fileItem.fileName) {
            // File object from API (pre-existing)
            const blobFile = await fetch(fileItem.blobPath).then((res) =>
              res.blob()
            );
            const file = new File([blobFile], fileItem.fileName, {
              type: blobFile.type,
            });
            formData.append("Files", file);
          }
        }
      }

      // Call API based on edit mode
      const response =
        id !== null && id !== undefined
          ? await updateTimesheet(
              formData,
              userTypeId ? userTypeId : currentUserTypeId
            )
          : await addNewTimeSheet(
              formData,
              userTypeId ? userTypeId : currentUserTypeId
            );

      const actionType = isDraft
        ? "saved as draft"
        : userType === "external"
        ? "submitted for approval"
        : "submitted";

      toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail:
          id !== null && id !== undefined
            ? `Timesheet has been updated and ${actionType}`
            : `Timesheet has been ${actionType}`,
        life: 3000,
      });

      // Navigate back to list after successful submission
      setTimeout(() => {
        navigate("/user/timesheet");
      }, 1500);
    } catch (error) {
      appInsights.trackException("Post/Edit addTimeSheet", {
        exception: error,
      });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message
          ? error?.message
          : error?.status === 400
          ? "User not Found"
          : error?.status === 500
          ? "Internal Server Error"
          : error?.status === 404
          ? "User not Found"
          : "Error occurred while submitting details",
        life: 5000,
      });
    } finally {
      setSubmitting(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      entries: [],
    },
    onSubmit: handleSubmit,
  });
  const clearForm = () => {
    formik.resetForm({
      values: {
        entries: formik.initialValues.entries.map((entry) => ({
          date: entry.date,
          projects: [], // Completely empty project list
        })),
      },
    });
  };
  const countTotalHrTimeSheet = () => {
    formik.values?.entries.forEach((entry) => {
      total += entry?.projects?.reduce((acc, cur) => {
        acc =
          cur?.project && cur?.project !== "dp-1" ? (cur?.hours ?? 0) + acc : 0;
        return acc;
      }, 0);
    });
    return total;
  };
  const handleHoursChange = (e, rowIndex, projectIndex) => {
    const newValue = e.value || 0;
    const currentEntry = formik.values?.entries[rowIndex];
    const currentProject = currentEntry?.projects[projectIndex];

    // Check if hours exceed 8 for a single project
    if (newValue > 12) {
      showToast("error", "Error", "Hours cannot exceed 12 for a project");
       //return;
    }

    // Allow 0 hours for project IDs 1 and 2, validate others
    if (
      currentProject?.project &&
      newValue === 0 &&
      !["dp-1", "dp-2"].includes(parseInt(currentProject?.project))
    ) {
      // showToast(
      //   'error',
      //   'Error',
      //   'Hours cannot be 0 when a project is selected'
      // );
      // return;
    }

    // Calculate total hours for this day excluding current project
    const totalHoursForDay = currentEntry?.projects.reduce((sum, proj, idx) => {
      return idx !== projectIndex ? sum + (proj?.hours || 0) : sum;
    }, 0);

    // Check if new total would exceed 8 hours
    if (totalHoursForDay + newValue > 8) {
      // showToast(
      //   'error',
      //   'Error',
      //   'Total hours per day cannot exceed 8 hours'
      // );
      // return;
    }

    formik.setFieldValue(
      `entries.${rowIndex}.projects.${projectIndex}.hours`,
      newValue
    );
  };
  useEffect(() => {
    countTotalHrTimeSheet();
  }, [formik?.values]);

  const handleViewTypeChange = (e) => {
    if (id !== null && id !== undefined) return; // Don't handle view type changes in edit mode
    setDefaultProject({ label: "Select a Project", value: null });
    setViewType(e?.value);
    clearForm();
    setSelectedWeek(null);
    setSelectedDates([]);
    formik.setValues({ entries: [] }); // Reset formik values when view type changes

    if (e?.value === "monthly") {
      setWeekList([]);
      setBiWeeklyPeriods([]);
      handleSelectedDatesForMonth(selectedMonth);
    } else if (e?.value === "weekly") {
      setBiWeeklyPeriods([]);
      getWeekList(selectedMonth);
    } else if (e?.value === "biweekly") {
      setWeekList([]);
      getBiWeeklyPeriods(selectedMonth);
    }
  };

  const getTimesheetData = async (id) => {
    try {
      const response = await getTimesheetById(id);
      const data = [response] || [];
      const formattedData = data?.map((timesheet) => {
        return {
          periodId: timesheet?.id,
          blobPath: timesheet?.blobPath,
          userName: timesheet?.userName,
          userTypeId: timesheet?.userTypeId,
          periodType: timesheet.timesheetType,
          monthYear: timesheet.monthYear,
          weekRange: timesheet.weekRange,
          documents: timesheet?.documents,
          periodRange: `${formatDateForDisplay(
            timesheet?.startDate || Date.now()
          )} - ${formatDateForDisplay(timesheet?.endDate || Date.now())}`,
          totalHours: timesheet?.totalHours || 0,
          status: timesheet?.status,
          projects: (timesheet?.entries || [])?.map((entry) => ({
            projectName: entry?.projectName || "",
            projectId: entry?.projectId,
            defaultProjectId: entry?.defaultProjectId,
            hours: entry?.hours || 0,
            date: entry?.entryDate,
            comments: entry?.comments || "",
            type: entry?.projectType === "Default" ? 0 : 1,
          })),
        };
      });
      setTimesheetDataOnEdit(formattedData);
      setSelectedFile(formattedData[0]?.documents);
    } catch (error) {
      console.error("Error fetching timesheet data:", error);
      appInsights.trackException("Get addTimeSheet", { exception: error });
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.message || "Something went wrong at Server Side",
        life: 3000,
      });
    }
  };
  const formatDateForDisplay = (date) => {
    return format(new Date(date), "MM/dd/yy");
  };
 

  useEffect(() => {
    if (
      id !== null &&
      id !== undefined &&
      timesheetDataOnEdit?.length > 0 &&
      projects.length >= 0
    ) {
      if (!hasInitialized.current) {
        // Only populate once
        populateTimesheetOnEdit(timesheetDataOnEdit[0]);
        hasInitialized.current = true; // Mark as initialized
      }
    } else if (
      selectedDates?.length > 0 &&
      (id == null || id == undefined) &&
      projects.length >= 0
    ) {
      const entries = selectedDates?.map((date) => {
        return {
          date: date,
          projects: [
            {
              project: null,
              hours: 0,
              comments: "",
              type: null,
            },
          ],
        };
      });
      formik.setValues({ entries });
    }
  }, [selectedDates, projects, id, timesheetDataOnEdit]);

  const populateTimesheetOnEdit = (timesheetData) => {
    if (
      !timesheetData ||
      !timesheetData?.projects ||
      !timesheetData?.periodRange
    )
      return;

    // Extract start and end date from periodRange and handle both date formats
    const [start, end] = timesheetData?.periodRange?.split("-")?.map((date) => {
      const trimmedDate = date?.trim();
      try {
        // Try MM/dd/yyyy format first
        return parse(trimmedDate, "MM/dd/yyyy", new Date());
      } catch (error) {
        try {
          // Fallback to dd/MM/yyyy format
          return parse(trimmedDate, "dd/MM/yyyy", new Date());
        } catch (error) {
          console.error("Error parsing date:", error);
          return new Date();
        }
      }
    });

    let allDates = [];
    let currentDate = start;

    while (currentDate <= end) {
      allDates.push(format(currentDate, "EEE, MMM dd"));
      currentDate = addDays(currentDate, 1);
    }
    setSelectedDates(allDates);

    // Use useRef to prevent infinite loop when updating Formik
    if (!hasInitialized.current) {
      hasInitialized.current = true;
      setTimeout(() => {
        formik.setValues((prevValues) => {
          const formattedEntries = allDates?.map((date) => {
            const existingEntry = prevValues?.entries?.find(
              (entry) => entry?.date === date
            );
            const projectsForDate = timesheetData.projects
              ?.filter(
                (project) =>
                  format(new Date(project.date), "EEE, MMM dd") === date
              )
              ?.map((project) => ({
                project: !project?.projectId? `dp-${project?.defaultProjectId}`: parseInt(project?.projectId),
                hours: project?.hours,
                comments: project?.comments || " ",
                // existingEntry?.projects?.find(
                //   (p) => p?.project === parseInt(project?.projectId)
                // )?.comments || "",
              }));

            return {
              date,
              projects:
                projectsForDate?.length > 0
                  ? projectsForDate
                  : existingEntry?.projects || [
                      { project: null, hours: 0, comments: "", type: null },
                    ],
            };
          });

          return { ...prevValues, entries: formattedEntries };
        });
      }, 100);
    }
  };

  const handleProjectChange = (e, rowIndex, projectIndex) => {
    const selectedProject = e.value;
    const isDefaultProject = Number.isNaN(Number(e.value));
    // Check if selected project is from default projects
    if (
      selectedProject &&
      defaultProject &&
      selectedProject === defaultProject.toString()
    ) {
      // Reset to a single project for this day

      formik.setFieldValue(`entries.${rowIndex}.projects`, [
        {
          project: selectedProject,
          hours: 8,
          comments:
            formik.values?.entries[rowIndex]?.projects[projectIndex]
              ?.comments || "",
        },
      ]);
      return;
    }

    // Check if this project is already selected for this date
    const isDuplicateProject = formik.values?.entries[rowIndex]?.projects.some(
      (proj, idx) => idx !== projectIndex && proj?.project === selectedProject
    );

    if (isDuplicateProject) {
      showToast(
        "error",
        "Error",
        "This project is already selected for this date. Please choose a different project."
      );
      return;
    }

    const updatedEntries = [...formik.values.entries];
    const currentEntry = updatedEntries[rowIndex];
    const dayName = currentEntry?.date?.split(",")[0];
    const isWeekend = dayName === "Sat" || dayName === "Sun";
    const projectId = selectedProject ? selectedProject : null;

    // Check for restricted projects (7 or 8) in any row for this day
    const hasRestrictedProject = currentEntry.projects.some(
      (proj) =>
        proj?.project && ["dp-1", "dp-2"].includes(parseInt(proj?.project))
    );

    // Check if any other projects exist (excluding current selection)
    const hasOtherProjects = currentEntry?.projects.some(
      (proj, idx) =>
        idx !== projectIndex &&
        proj?.project &&
        !["dp-1", "dp-2", "dp-3"].includes(proj?.project)
    );

    // If trying to select a restricted project when other projects exist
    if (["dp-2", "dp-3"].includes(projectId) && hasOtherProjects) {
      showToast(
        "error",
        "Error",
        "Cannot select holiday when other projects are already selected for this day."
      );
      return;
    }

    // Set hours based on project ID and weekend status
    if (formik.values.entries[rowIndex]?.projects?.length == 1) {
      const hours =
        projectId === "dp-1" || projectId === "dp-2" || projectId === "dp-3"
          ? 0 // Always 0 for project 1 and 2
          : !isWeekend && selectedProject
          ? 8
          : 0; // 8 for weekdays with project, 0 otherwise

      updatedEntries[rowIndex].projects[projectIndex] = {
        ...updatedEntries[rowIndex].projects[projectIndex],
        project: selectedProject,
        hours: hours,
      };

      formik.setValues({ ...formik.values, entries: updatedEntries });
    } else {
      updatedEntries[rowIndex].projects[projectIndex] = {
        ...updatedEntries[rowIndex].projects[projectIndex],
        project: selectedProject,
      };

      formik.setValues({ ...formik.values, entries: updatedEntries });
    }

    // Clear comments if no project is selected
    if (!selectedProject) {
      formik.setFieldValue(
        `entries.${rowIndex}.projects.${projectIndex}.comments`,
        ""
      );
    }
  };

  const handleDefaultProjectChange = (e) => {
    setDefaultProject(e.value);
    const selectedProject = e?.value || null;
    if (!e.value) return;
    clearForm();

    formik.setValues((prevValues) => {
      const updatedEntries = prevValues?.entries?.map((entry) => {
        const dayName = entry?.date?.split(",")[0];
        const isWeekend = dayName === "Sat" || dayName === "Sun";

        if (isWeekend) {
          return {
            ...entry,
            projects: entry?.projects?.map((project) => ({
              ...project,
              project: null,
              hours: 0,
              comments: "",
            })),
          };
        }

        return {
          ...entry,
          projects: [
            {
              project: e?.value,
              hours: isNaN(Number(e?.value)) ? 0 : 8,
              comments: "",
            },
          ],
        };
      });

      return {
        ...prevValues,
        entries: updatedEntries,
      };
    });
  };

  const handleAddProject = (rowIndex, rowData) => {
    const availableProjects = projects1?.filter(
      (p) =>
        !formik.values?.entries[rowIndex]?.projects.some(
          (proj) => proj?.project === p?.value
        )
    );
    if (availableProjects?.length === 0) {
      return;
    }

    // Calculate total hours for this day
    const totalHoursForDay = rowData?.projects.reduce(
      (sum, proj) => sum + (proj?.hours || 0),
      0
    );

    // Check if adding default 8 hours would exceed limit
    const remainingHours = 12 - totalHoursForDay;

    if (remainingHours <= 0) {
      showToast(
        "error",
        "Error",
        "Cannot add more projects as total hours for this day is already at maximum (12 hours)"
      );
      if (
        formik.values?.entries[rowIndex]?.projects.some((x) => x?.hours == 0)
      ) {
        const updatedProjects = formik.values.entries[
          rowIndex
        ]?.projects?.filter((x) => x?.hours !== 0);
        // Use setFieldValue to update Formik's state
        formik.setFieldValue(`entries[${rowIndex}].projects`, updatedProjects);
      }
      return;
    }

    const updatedProjects = [
      ...rowData?.projects,
      {
        project: availableProjects[0]?.value,
        hours: Math.min(remainingHours, 8),
        comments: "",
      },
    ];

    formik.setFieldValue(`entries.${rowIndex}.projects`, updatedProjects);
  };

  return (
    <div style={{ position: "relative", minHeight: "100vh" }}>
      <Toast ref={toast} position="top-center" />
      <Tooltip target=".pi-info-circle" />
      <div className="layout-wrapper mx-3 my-3">
        <div className="layout-content">
          {loading ? (
            <Spinner />
          ) : submitting ? (
            <Spinner fullPage />
          ) : (
            <div className="px-2 py-3">
              <div className="header-container xl:pl-2">
                <div className="header-left">
                  <h2 className="page-title">
                    {id !== null && id !== undefined
                      ? "Edit Timesheet"
                      : "Add Timesheet"}
                  </h2>
                </div>
                <div className="header-right">
                  <Button
                    icon="pi pi-arrow-left"
                    label="Back to List"
                    className="p-button-text back-button"
                    onClick={() => navigate("/user/timesheet")}
                  />
                </div>
              </div>
              <div className="grid">
                <div className="col-12">
                  <div className="grid mb-3">
                    <div className="col-12 lg:col-7">
                      <div className="grid">
                        <div className="col-12 md:col-4">
                          <Dropdown
                            value={viewType}
                            onChange={handleViewTypeChange}
                            options={options}
                            optionLabel="label"
                            placeholder="Select View"
                            className="filter-dropdown w-full"
                            disabled={id !== null && id !== undefined}
                          />
                        </div>
                        <div className="col-12 md:col-4">
                          <Dropdown
                            value={selectedMonth}
                            options={monthList}
                            onChange={(e) => {
                              setSelectedMonth(e.value);
                              clearForm();
                              setDefaultProject({
                                label: "Select a Project",
                                value: null,
                              });
                            }}
                            placeholder="Select Month"
                            className="filter-dropdown w-full"
                            disabled={id !== null && id !== undefined}
                          />
                        </div>
                        <div className="col-12 md:col-4">
                          {(viewType === "weekly" ||
                            viewType === "biweekly") && (
                            <Dropdown
                              value={selectedWeek}
                              options={
                                viewType === "weekly"
                                  ? weekList
                                  : biWeeklyPeriods
                              }
                              onChange={(e) => {
                                setSelectedWeek(e.value);
                                clearForm();
                                setDefaultProject({
                                  label: "Select a Project",
                                  value: null,
                                });
                              }}
                              placeholder={`Select ${
                                viewType === "weekly" ? "Week" : "Period"
                              }`}
                              className="filter-dropdown w-full"
                              disabled={id !== null && id !== undefined}
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 lg:col-5">
                      <div className="action-buttons">
                        <div
                          className={`upload-button-container ${
                            isExternalUser ? "external-user" : ""
                          }`}
                        >
                          <input
                            type="file"
                            ref={fileInputRef}
                            onChange={handleFileUpload}
                            style={{ display: "none" }}
                            accept=".pdf,.doc,.docx,.xls,.xlsx"
                          />
                          <div className="upload-section">
                            {isExternalUser && (
                              <small
                                className="upload-required-text"
                                style={{
                                  display: "block",
                                  marginTop: "8px",
                                  fontSize: "12px",
                                }}
                              >
                                {!selectedFile ? (
                                  <> *Required for external projects</>
                                ) : (
                                  <span>&nbsp;&nbsp;</span>
                                )}
                              </small>
                            )}
                            <Button
                              icon="pi pi-upload"
                              label="Upload Document"
                              onClick={handleUploadClick}
                              className={`p-button-secondary ${
                                isExternalUser ? "" : ""
                              }`}
                            />
                          </div>
                        </div>
                        <div
                          className="submit-buttons"
                          // style={{ marginBottom: "5px" }}
                        >
                          <Button
                            type="button"
                            label="Draft"
                            className="p-button-secondary"
                            onClick={() => handleSubmit(formik.values, true)}
                          />
                          <Button
                            type="button"
                            label="Submit"
                            className="p-button-primary"
                            onClick={() => handleSubmit(formik.values)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {selectedFile && (
                    <div className="selected-file">
                      <i className="pi pi-file mr-2" />
                      {id !== null && id !== undefined ? (
                        <span>
                          {selectedFile?.name
                            ? selectedFile.name
                            : decodeURIComponent(
                                selectedFile?.substring(
                                  selectedFile.lastIndexOf("/") + 1
                                )
                              )}
                        </span>
                      ) : (
                        <span>{selectedFile?.name}</span>
                      )}
                      <i
                        className="pi pi-times ml-2 cursor-pointer"
                        onClick={() => setSelectedFile(null)}
                        style={{ color: "#dc3545" }}
                      />
                    </div>
                  )} */}
                  {selectedFile?.length > 0 && (
                    <div className="selected-files">
                      {selectedFile?.map((file, index) => (
                        <div key={index} className="selected-file">
                          <i className="pi pi-file mr-2" />
                          <span>
                            {file.type === "uploaded"
                              ? file.file.name
                              : file.fileName}
                          </span>
                          <i
                            className="pi pi-times ml-2 cursor-pointer"
                            onClick={() => {
                              const updatedFiles = selectedFile?.filter(
                                (_, i) => i !== index
                              );
                              setSelectedFile(updatedFiles);
                            }}
                            style={{ color: "#dc3545" }}
                          />
                        </div>
                      ))}
                    </div>
                  )}

                  <div
                    className="grid mx-2 align-items-center"
                    style={{ backgroundColor: "#f8f9fa" }}
                  >
                    <div className="col-12 md:col-3 lg:col-2">
                      <span className="default-project-label md:ms-3">
                        Current Project:
                      </span>
                    </div>
                    <div className="col-12 md:col-6 lg:col-4">
                      <Dropdown
                        value={defaultProject}
                        options={projects}
                        onChange={handleDefaultProjectChange}
                        placeholder="Select Default Project"
                        className="w-full"
                      />
                    </div>
                    <div className="col-12 lg:col-6">
                      <small className="text-gray-500">
                        *This will auto-fill projects for weekdays. You can
                        still modify individual entries.
                      </small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex justify-content-end items-center pr-3">
                <span className="mr-2">
                  <h4 className="inline align-baseline">Total Hours:</h4>
                </span>
                <span className="inline align-baseline">
                  {countTotalHrTimeSheet()}
                </span>
              </div>
              <div>
                {/* U */}
                <FormikProvider value={formik}>
                  <form onSubmit={formik.handleSubmit} className="py-3 px-2">
                    <DataTable
                      value={formik.values.entries}
                      responsiveLayout="scroll"
                      showGridlines
                      rows={10}
                      className="timesheet-table"
                      tableStyle={{ width: "100%" }}
                      breakpoint="960px"
                      // scrollable
                    >
                      <Column
                        field="date"
                        header="Date"
                        style={{ width: "15%" }}
                        body={(rowData) => (
                          <div className="date-cell">{rowData.date}</div>
                        )}
                      />
                      <Column
                        header={
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            Project
                            <i
                              className="pi pi-info-circle"
                              data-pr-tooltip="Select N/A if you didn’t work on a project any day."
                              data-pr-position="top"
                              style={{ cursor: "pointer", color: "#6c757d" }}
                            />
                            <Tooltip target=".pi-info-circle" />
                          </div>
                        }
                        style={{ width: "28%" }}
                        body={(rowData, { rowIndex }) => (
                          <div className="projects-container">
                            {[...rowData?.projects]
                              .reverse()
                              .map((project, idx) => {
                                const projectIndex =
                                  rowData?.projects?.length - 1 - idx;
                                const hasOtherProjects = rowData?.projects.some(
                                  (proj, idx) =>
                                    idx !== projectIndex &&
                                    proj?.project &&
                                    !["dp-2", "dp-3"].includes(proj?.project)
                                );
                                // Filter out restricted projects if other projects exist
                                const availableProjects = projects1.filter(
                                  (p) => {
                                    const projectId =
                                      parseInt(p.value) || p.value;
                                    if (["dp-2", "dp-3"].includes(projectId)) {
                                      // Only show restricted projects if no other projects exist
                                      return !hasOtherProjects;
                                    }
                                    return true;
                                  }
                                );
                              
                                return (
                                  <div
                                    key={projectIndex}
                                    className="project-row pb-2 border-none"
                                  >
                                    <Dropdown
                                      value={
                                        formik.values?.entries[rowIndex]
                                          ?.projects[projectIndex]?.project || {
                                          label: "Select a Project",
                                          value: null,
                                        }
                                      }
                                      options={availableProjects}
                                      onChange={(e) =>
                                        handleProjectChange(
                                          e,
                                          rowIndex,
                                          projectIndex
                                        )
                                      }
                                      // placeholder="Select a project"
                                      className="w-full"
                                    />
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      />
                      <Column
                        header="Hours"
                        style={{ width: "10%" }} // Reduced width
                        body={(rowData, { rowIndex }) => (
                          <div className="projects-container">
                            {[...rowData.projects]
                              .reverse()
                              .map((project, idx) => {
                                const projectIndex =
                                  rowData.projects?.length - 1 - idx;
                                const hasRestrictedProject =
                                  rowData?.projects.some(
                                    (proj) =>
                                      proj?.project &&
                                      ["dp-2", "dp-3"].includes(proj?.project)
                                  );

                                return (
                                  <div
                                    key={projectIndex}
                                    className="project-row1  border-none"
                                  >
                                    <InputNumber
                                      value={
                                        formik.values.entries[rowIndex]
                                          ?.projects[projectIndex]?.hours
                                      }
                                      className="col-1 p-0 pb-2"
                                      onValueChange={(e) =>
                                        handleHoursChange(
                                          e,
                                          rowIndex,
                                          projectIndex
                                        )
                                      }
                                      disabled={hasRestrictedProject}
                                      min={0}
                                      // max={8}
                                      style={{ width: "56px" }} // Reduced input width
                                    />
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      />
                      <Column
                        header="Comments"
                        style={{ width: "25%" }}
                        body={(rowData, { rowIndex }) => (
                          <div className="projects-container">
                            {[...rowData.projects]
                              .reverse()
                              .map((project, idx) => {
                                const projectIndex =
                                  rowData?.projects?.length - 1 - idx;
                                const hasRestrictedProject =
                                  rowData?.projects.some(
                                    (proj) =>
                                      proj?.project &&
                                      ["dp-2", "dp-3"].includes(proj?.project)
                                  );
                                return (
                                  <div
                                    key={projectIndex}
                                    className="project-row pb-2 border-none"
                                  >
                                    <InputText
                                      value={
                                        formik.values.entries[rowIndex]
                                          ?.projects[projectIndex]?.comments
                                      }
                                      onChange={formik.handleChange}
                                      disabled={hasRestrictedProject}
                                      name={`entries.${rowIndex}.projects.${projectIndex}.comments`}
                                      placeholder="Add comments..."
                                      // className="w-full"
                                    />
                                  </div>
                                );
                              })}
                          </div>
                        )}
                      />
                      <Column
                        header="Actions"
                        style={{ width: "10%" }}
                        body={(rowData, { rowIndex }) => (
                          <div className="projects-container">
                            {[...rowData?.projects].reverse().map((_, idx) => {
                              const projectIndex =
                                rowData?.projects?.length - 1 - idx;

                              const currentProject =
                                rowData?.projects[projectIndex]?.project;

                              // ✅ Check if any project is still default/empty
                              const allProjectsAreDefault =
                                rowData?.projects.every(
                                  (proj) =>
                                    !proj?.project || // null or undefined
                                    proj?.project?.value === null // value set to null
                                );

                              // ✅ Check if restricted projects exist in this row
                              const hasRestrictedProjectInRow =
                                rowData?.projects.some(
                                  (proj) =>
                                    proj?.project &&
                                    ["dp-2", "dp-3"].includes(
                                      proj?.project?.value || proj?.project
                                    )
                                );

                              return (
                                <div
                                  key={`action-${rowIndex}-${projectIndex}`}
                                  className="project-row flex justify-end gap-2"
                                >
                                  {projectIndex === 0 && (
                                    <i
                                      className={`pi pi-plus p-2 ${
                                        !allProjectsAreDefault &&
                                        !hasRestrictedProjectInRow
                                          ? "cursor-pointer hover:bg-gray-100 text-blue-500"
                                          : "text-gray-400 cursor-not-allowed"
                                      }`}
                                      onClick={() =>
                                        !allProjectsAreDefault &&
                                        !hasRestrictedProjectInRow &&
                                        handleAddProject(rowIndex, rowData)
                                      }
                                      style={{
                                        opacity:
                                          !allProjectsAreDefault &&
                                          !hasRestrictedProjectInRow
                                            ? 1
                                            : 0.5,
                                        pointerEvents:
                                          !allProjectsAreDefault &&
                                          !hasRestrictedProjectInRow
                                            ? "auto"
                                            : "none",
                                      }}
                                    />
                                  )}
                                  {rowData?.projects?.length > 1 && (
                                    <i
                                      className="pi pi-trash p-2 cursor-pointer hover:bg-gray-100 rounded-lg text-red-500"
                                      onClick={() => {
                                        const updatedProjects = [
                                          ...rowData.projects,
                                        ];
                                        updatedProjects.splice(projectIndex, 1);
                                        formik.setFieldValue(
                                          `entries.${rowIndex}.projects`,
                                          updatedProjects
                                        );
                                      }}
                                    />
                                  )}
                                </div>
                              );
                            })}
                          </div>
                        )}
                      />
                    </DataTable>
                  </form>
                </FormikProvider>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default AddNewTimeSheet;
